import { graphql, useStaticQuery } from 'gatsby'
import React from 'react'

import Page from '@cinch/oxd-pages/cambridge/find-vehicle-cambridge/src'
import OxfordPage from '@cinch/oxd-pages/find-vehicle/src'
import SEO, { Breadcrumb } from '../components/seo'
import getParam from './../utils/url-search-param'
import { FEATURES, hasFeatureFlag } from '@cinch/oxd-utils/feature-flags/src'
import { getEnv, Env } from '@cinch/oxd-utils/env/src'

const FindYourCar: React.FC<{ location: Location }> = ({ location }) => {
  const data: any = useStaticQuery(graphql`
    query VehicleDetailQuery {
      allTranslations {
        edges {
          node {
            banner {
              title
              subTitle
            }
            findVehicle {
              title
              description
              search {
                search
                placeholder
              }
              saveSearch {
                button
                untitledName
              }
              filters {
                title
                settings
                filters
                clear
                location
                money {
                  title
                  cash
                  partEx
                  finance
                  submit
                  total
                }
                within
                of
              }
              fuelFinder {
                topline
                strapline
                smallPrint
                tagline
                firstBulletPoint
                secondBulletPoint
                cta {
                  saveNow
                }
                fuelSaver
              }
              noResults {
                withDelivery
                withoutDelivery
              }
              deliveryPreference {
                title
                moreInfo
                bullet1
                bullet2
                onLabel
                offLabel
              }
              deliveryModal {
                bullet1
                bullet2
                bullet3
                bullet4
                bullet5
                bullet6
              }
            }
          }
        }
      }
    }
  `)

  const { banner, findVehicle: i18n } = data.allTranslations.edges[0].node

  const breadcrumbs: Breadcrumb[] = []

  if (location) {
    const pageUrl = `${getEnv(Env.SiteUrl)}${location.pathname}`
    breadcrumbs.push({
      name: i18n.title,
      item: pageUrl,
    })
  }

  return (
    <>
      <SEO title={i18n.title} desc={i18n.description} breadcrumbs={breadcrumbs} />
      {hasFeatureFlag(FEATURES.CAMBRIDGE) ? (
        <Page i18n={i18n} initialSearchValue={getParam(location.search)('query')} banner={banner} />
      ) : (
        <OxfordPage i18n={i18n} initialSearchValue={getParam(location.search)('query')} banner={banner} />
      )}
    </>
  )
}

export default FindYourCar
